import React from "react";
export default function Spinner({
  size = 28,
  thickness = 3,
  color = "#2563eb",
  label = "Loading",
  inline = false,
}) {
  const style = {
    width: size,
    height: size,
    borderWidth: thickness,
    borderTopColor: color,
  };

  const spinner = (
    <div className="spinner" style={style} role="status" aria-live="polite" aria-label={label}>
      <span className="sr-only">{label}...</span>
    </div>
  );

  if (inline) return spinner;

  return (
    <div className="spinner-center">
      {spinner}
    </div>
  );
}
